import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    descriptionText: {
        overflow: 'auto',
        transition: 'max-height 0.5s ease-in',
        maxHeight: 500,
        fontSize: pxToRem(14),
        fontWeight: 400,
    },
    textContainer: {
        position: 'relative',
        width: '100%',
        overflowWrap: 'anywhere',
        whiteSpace: 'pre-wrap',
        //For overriding Browser  user-agent style/auto created style for content editable, style from ms word document etc.
        '& span,& i, & div, & b, & strong, & li, & blockquote, & p, & u': {
            fontFamily: 'inherit !important',
            fontSize: 'inherit !important',
            lineHeight: 'inherit !important',
            textDecoration: 'none !important',
            color: 'inherit !important',
            border: 'none !important',
            width: 'auto !important',
        },
        '& p': {
            //MS word margin issue
            marginTop: 0,
            marginBottom: '1rem',
        },
    },
    descriptionContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    descriptionHeading: {
        marginRight: theme.spacing(3),
        textTransform: 'uppercase',
        fontSize: pxToRem(13),
        fontWeight: 500,
        width: 85,
    },
}))

interface ViewDescriptionProps {
    longDescription?: string
}

export const ViewDescription: React.FC<ViewDescriptionProps> = ({
    longDescription,
}) => {
    const classes = useStyles()
    return (
        <div className={classes.descriptionContainer}>
            <Typography variant="body1" className={classes.descriptionHeading}>
                Description:
            </Typography>
            <GridContainer
                item
                className={clsx(classes.descriptionText, classes.textContainer)}
            >
                <Typography
                    variant="inherit"
                    data-testid="lblLongDescription"
                    dangerouslySetInnerHTML={{
                        __html: longDescription ?? '',
                    }}
                />
            </GridContainer>
        </div>
    )
}
